import React from 'react'
import {
  TextInput,
  required,
  SelectInput,
  ImageInput,
  ImageField,
  minLength
} from 'react-admin'

import { ResourceSelector } from 'components'
import { Grid, Paper, Typography, makeStyles } from '@material-ui/core'
import { numberValidate } from 'utils/formValidations'
import { Tooltip } from 'components'

const useStyles = makeStyles({
  container: {
    width: '100%',
  },
  gridContainer: {
    width: '100%',
  },
  formContainer: {
    backgroundColor: '#F5F5F5',
  },
  paperContainer: {
    padding: 16,
  },
})

export const EditForm = (props: any) => {
  const classes = useStyles()

  const { formData } = props

  return (
    <Grid
      container
      direction="row"
      justify="center"
      alignItems="center"
      spacing={2}
      className={classes.gridContainer}
    >
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <Paper className={classes.paperContainer}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Typography variant="h5" color="textSecondary" gutterBottom>
              Editar Semana
            </Typography>
            <hr />
          </Grid>

          <Grid
            container
            spacing={2}
            className={classes.gridContainer}
            direction="column"
          >
            <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
              <Typography
                variant="subtitle2"
                color="textPrimary"
              >{`Para o ID: `}</Typography>
              <Typography variant="caption" color="textSecondary">
                {` Digite uma parte do nome do curso/série que você deseja vincular.`}
              </Typography>
              <Tooltip title={'weeks.id'}>
                <ResourceSelector
                  fullWidth
                  label="Curso/Série"
                  resource="cms/grouper/courses"
                  source="grouper_id"
                  optionValue="id"
                  validate={[required('Obrigatório')]}
                  selectedValue={formData.grouper_id}
                />
              </Tooltip>
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <Tooltip title={'weeks.order'}>
                <TextInput
                  fullWidth
                  name="order"
                  label="Ordem"
                  source="order"
                  validate={[
                    required('Obrigatório'),
                    numberValidate,
                    minLength(2, 'Mínimo 2 caracteres numéricos'),
                  ]}
                />
              </Tooltip>
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Tooltip title={'weeks.title'}>
                <TextInput
                  fullWidth
                  label="Título"
                  source="title"
                  validate={[required('Obrigatório')]}
                />
              </Tooltip>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  )
}
